import { supabase } from '@/utils/supabase';
import { VOLUME_BONUS_FOUNDATION_FLAG } from '@/constants/volumeBonus';

export type VolumeBonusFoundationStatus = 'present' | 'absent' | 'unknown';

const CACHE_TTL_MS = 10 * 60 * 1000;
let cached: { status: 'present' | 'absent'; expiresAt: number } | undefined;
let pending: Promise<VolumeBonusFoundationStatus> | undefined;

/** Foundation presence is independent of whether enrollment is enabled. */
export function hasVolumeBonusFoundation(): Promise<VolumeBonusFoundationStatus> {
  if (cached && Date.now() < cached.expiresAt) {
    return Promise.resolve(cached.status);
  }
  if (!pending) {
    pending = (async () => {
      const { data, error } = await supabase.from('feature_flags')
        .select('flag_name').eq('flag_name', VOLUME_BONUS_FOUNDATION_FLAG).maybeSingle();
      if (error) {
        throw error;
      }
      const status = data === null ? 'absent' : 'present';
      cached = { status, expiresAt: Date.now() + CACHE_TTL_MS };
      return status;
    })().catch(() => 'unknown' as const).finally(() => {
      pending = undefined;
    });
  }
  return pending;
}
